import styled from 'styled-components';

export const QuantityContainer = styled.div`
    display: flex;
    align-items: flex-start;
`;
